import React, { useEffect, useLayoutEffect } from "react";
// import { Stepper, Step } from "react-form-stepper";
import { useState } from "react";
import { useStore } from "Store";
import { Stepper, Step } from "react-form-stepper";
function StepperComp() {
    const [Active, setActive] = useState(0);
    const { mainStatus } = useStore((state: any) => state);

    useLayoutEffect(() => {
        console.log(mainStatus);
        let ActiveData = [
            "scheduling",
            "documents",
            "tax_preparation",
            "payments",
            "client_review",
            "e_filing",
        ];
        let status = mainStatus || "scheduling";
        let index = ActiveData.findIndex((item) => item == status);
        if (index != -1 && index >= 0 && index <= 5) {
            setActive(index);
        }
    }, [mainStatus]);
    console.log(Active);
    let label = [
        { label: "Scheduling" },
        { label: "Documents" },
        { label: "Tax Preparation & review" },
        { label: "Payment" },
        { label: "Review" },
        { label: "E Filing" },
    ];

    return (
        <div>
            <Stepper
                activeStep={Active}
                steps={label}
                connectorStyleConfig={{
                    disabledColor: "#bdbdbd", // Gray for disabled steps
                    activeColor: "#66c4c1", // Light Green for ongoing step
                    completedColor: "#2db2bc", // Dark Green for completed step
                    size: 1,
                    stepSize: "2em",
                    style: "solid",
                }}
                connectorStateColors
                styleConfig={{
                    activeBgColor: "#2db2bc", // Light Green for ongoing step
                    activeTextColor: "white", // Dark Green text for ongoing step
                    completedBgColor: "#2db2bc", // Dark Green for completed step
                    completedTextColor: "#ffffff", // White text for completed step
                    inactiveBgColor: "#e0e0e0", // Light Gray for inactive step
                    inactiveTextColor: "#ffffff", // White text for inactive step
                    size: "2em",
                    circleFontSize: "1rem",
                    labelFontSize: "0.875rem",
                    borderRadius: "50%",
                    fontWeight: 500,
                }}
            />
        </div>
    );
}

export default StepperComp;
